import React, { useRef, useState, useEffect } from 'react';
import styles from '../diretrizprecatorios/diretrizprecatorios.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado3 from '../../components/LinkPersonalizado3/linkPersonalizado3.tsx';

const Diretrizprecatorios: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);

    return (
        <div className={styles.diretrizprecatorios}>
            <div className={styles["body-thunder"]} >
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mt-4 mb-0">DIRETRIZ</h1>
                    <p className="mb-6 text-center">ASSESSORIA EM PRECATÓRIOS</p>
                    <div className={styles.links}>
                        <LinkPersonalizado3
                            href="https://wa.me/5511978680348?text=Olá! Estou interessado na compra e venda de precatórios e gostaria de obter mais informações sobre o processo. Poderia me ajudar?"
                            title="WHATSAPP"
                        />
                        <LinkPersonalizado3
                            href="https://www.instagram.com/diretrizprecatorios?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                        />
                        <LinkPersonalizado3
                            href="https://www.diretrizprecatorios.com.br"
                            title="SITE"
                        />
                        <LinkPersonalizado3
                            href="https://maps.app.goo.gl/BGo6re7NR6XJaee26"
                            title="LOCALIZAÇÃO"
                        />
                    </div>
                    <div>
                        <img width={250} src={require("./src/footer.png")} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Diretrizprecatorios;
